import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SmallCardDataFromDb, LargeCardDataFromDb } from '../../shared/interfaces/card-data';
import {
    IPipelineParameters,
    ICloserAssignedData,
    IPipelineProductParameters,
    IPipelineProductData,
    ILoanCategoryDistData,
    IPipelineCategoryDistData,
} from '../interfaces/pipeline-data';

@Injectable({
    providedIn: 'root',
})
export class PipelineService {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private componentName = 'pipeline';
    private _url = (this.serverUrl + '/api/v{version}/{componentName}')
        .replace('{version}', this.version)
        .replace('{componentName}', this.componentName);

    constructor(private _http: HttpClient) {}

    getSmallCardData(parameters: IPipelineParameters): Observable<SmallCardDataFromDb[]> {
        return this._http.post<SmallCardDataFromDb[]>(this._url + '/bySmallCard/', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    getLargeCardData(parameters: IPipelineParameters): Observable<LargeCardDataFromDb[]> {
        return this._http.post<LargeCardDataFromDb[]>(this._url + '/byLargeCard/', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    getCloserAssignedData(parameters: IPipelineParameters): Observable<ICloserAssignedData[]> {
        return this._http.post<ICloserAssignedData[]>(
            this._url + '/GetCloserAssignedData/',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    // getSalesFunnel(parameters: IPipelineParameters): Observable<IPipelineSalesFunnel[]> {
    //     return this._http.post<IPipelineSalesFunnel[]>(this._url + '/sales/funnel', parameters, {
    //         headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    //     });
    // }

    getPipelineProduct(parameters: IPipelineProductParameters): Observable<IPipelineProductData[]> {
        return this._http.post<IPipelineProductData[]>(
            this._url + '/GetPipelineProduct/',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    displayActivePipelineLoanCategoryDistribution(
        parameters: IPipelineParameters
    ): Observable<ILoanCategoryDistData[]> {
        return this._http.post<ILoanCategoryDistData[]>(
            this._url + '/DisplayActivePipelineLoanCategoryDistribution/',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    displayPipelineLoanTypeGroupDistribution(parameters: IPipelineParameters): Observable<any[]> {
        return this._http.post<IPipelineCategoryDistData[]>(
            this._url + '/DisplayPipelineLoanTypeGroupDistribution/',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }
}
